export default class Coroutiner {
	constructor(scene, generator) {
		this.scene = scene;
		this.complete = false;
		this.generator = generator;
	}

	start() {
		this.complete = false;
		this.scene.updateEvent.add(this.update, this);
	}

	stop() {
		this.complete = true;
		this.scene.updateEvent.remove(this.update);
		// console.log('stop generator');
	}

	update(time, delta) {
		if (this.complete) return;
		var gen = this.generator.next();
		this.complete = gen.done;
		if (this.complete) {
			this.stop();
		}
	}
}
